import request from '../utils/request.js'

export default {
  // 获取套餐信息
  getInfo (params) {
    return request.post(`company_setmeal/info`, params).then(res => res.data)
  },
  // 获取使用情况
  getUsage (params) {
    return request.post(`company_setmeal/usage`, params).then(res => res.data)
  },
  // 获取套餐详情
  getDetails (params) {
    return request.post(`company_setmeal/details`, params).then(res => res.data)
  },
  // 套餐续费
  renew (params) {
    return request.post(`company_setmeal/renew`, params).then(res => res.data)
  },
  // 套餐升级
  upgrade (params) {
    return request.post(`company_setmeal/upgrade`, params).then(res => res.data)
  },
  // 获取升级套餐列表
  getUpgradePlans (params) {
    return request.post(`company_setmeal/upgrade_plans`, params).then(res => res.data)
  },
  // 获取续费价格
  getRenewPrice (params) {
    return request.post(`company_setmeal/renew_price`, params).then(res => res.data)
  },
  // 获取企业可用余额统计
  getBalance (params) {
    return request.post(`company_setmeal/balance`, params).then(res => res.data)
  },
  // 使用套餐余额
  useBalance (params) {
    return request.post(`company_setmeal/useBalance`, params).then(res => res.data)
  },
  // 获取企业套餐列表
  getLists (params) {
    return request.post(`company_setmeal/lists`, params).then(res => res.data)
  },
  // 添加/编辑企业套餐
  addSetmeal (params) {
    return request.post(`company_setmeal/add`, params).then(res => res.data)
  },
  // 删除企业套餐
  deleteSetmeal (params) {
    return request.post(`company_setmeal/delete`, params).then(res => res.data)
  },
  // 获取企业套餐详情
  getDetail (params) {
    return request.post(`company_setmeal/detail`, params).then(res => res.data)
  },
  // 更新过期状态
  updateExpiredStatus (params) {
    return request.post(`company_setmeal/updateExpiredStatus`, params).then(res => res.data)
  },
  // 创建支付订单
  createPayment (params) {
    return request.post(`company_setmeal/createPayment`, params).then(res => res.data)
  },
  // 查询支付状态
  checkPaymentStatus (params) {
    return request.post(`company_setmeal/checkPaymentStatus`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/package.js